import { type CSSProperties } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Button, Text } from '~/commonComponents';
import PlusIcon from '~/images/icons/PlusIcon';
import { Colors } from '~/themes/colors';
import { CreateOnsiteInterviewSteps } from '../../CreateOnsiteInterview';

interface IAddMoreOnsiteInterviewButtonProps {
  jobPostingId: string;
  includeLocationState?: boolean;
  variant?: 'default' | 'lite';
  onTrack?: () => void;
}

const Styles = {
  Default: {
    width: 296,
  } as CSSProperties,
  Lite: {
    alignItems: 'center',
    backgroundColor: Colors.secondary_500,
    borderRadius: 25,
    boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.15), 0 6px 10px 2px rgba(0, 0, 0, 0.15)',
    display: 'inline-flex',
    flexShrink: 0,
    gap: 4,
    height: 30,
    justifyContent: 'center',
    padding: '8px 12px',
  } as CSSProperties,
};

export const AddMoreOnsiteInterviewButton = ({
  includeLocationState = false,
  jobPostingId,
  variant = 'default',
  onTrack,
}: IAddMoreOnsiteInterviewButtonProps) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const handleClick = () => {
    // Call tracking callback if provided
    onTrack?.();

    navigate(
      // eslint-disable-next-line max-len
      `/permanent-jobs/postings/${jobPostingId}/onsite-interviews/create/${CreateOnsiteInterviewSteps.WorkDetails}`,
      includeLocationState ? { state } : undefined,
    );
  };

  if (variant === 'lite') {
    return (
      <button style={Styles.Lite} onClick={handleClick}>
        <PlusIcon color={Colors.white} />
        <Text bold color={Colors.white} textAlign="center">
          Add Interviews
        </Text>
      </button>
    );
  }

  return <Button text="Add Interviews" style={Styles.Default} onClick={handleClick} />;
};
